export const getRole = (role: number): string => {
    switch (role) {
      case 1:
        return "ADMIN";
      case 2:
        return "ACCOUNTANT";
      case 3:
        return "LOGISTICS";
      case 4:
        return "DISPATCH";
      case 5:
        return "DOT";
      default:
        return "UNKNOWN ROLE";
    }
  };